<template>
    <div class="form-box">
        <el-form
            class="form__center"
            label-width="82px"
            size="small"
            style="margin-top: 30px;"
        >
            <el-form-item
                label="手机号："
            >
                {{ encrypted }}
            </el-form-item>
            <el-form-item label="验证码：">
                <el-input
                    v-model="formItem.code"
                    placeholder="请输入手机验证码"
                    style="width: 200px;margin-right: 30px"
                />
                <el-button
                    type="text"
                    :disabled="showCount"
                    @click="sendCaptcha"
                >
                    <span v-show="!showCount">{{ text }}</span>
                    <span v-show="showCount">{{ count }}秒后重新发送</span>
                </el-button>
            </el-form-item>
            <el-form-item>
                <el-button
                    class="btn-standard"
                    type="primary"
                    @click="onSubmit"
                >
                    下一步
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Step1',
    inject: ['goPage'],
    data () {
        return {
            formItem: {
                code: ''
            },
            showCount: false,
            timer: null,
            count: 60,
            text: '发送验证码'
        }
    },
    computed: {
        errors () {
            return this.$vuerify.$errors
        },
        encrypted () {
            let phone = this.info.phone || ''
            return phone.substring(0, 3) + ' **** ' + phone.substring(phone.length - 4)
        }
    },
    created () {
        if (JSON.stringify(this.$route.query) === '{}' || !this.$route.query.username || !this.$route.query.phone) {
            this.$message.error('系统错误，请重试')
            router.replace('/account/home')
        } else {
            this.info = this.$route.query
        }
    },
    vuerify: {
        'formItem.code': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入手机验证码'
            },
            {
                test: /^\d{6}$/,
                message: '请输入6位数字验证码'
            }
        ]
    },
    mounted () {
    },
    methods: {
        sendCaptcha () {
            this.$http.post('/api/sendsms', qs.stringify({
                phone: this.info.phone,
                type: 2
            })).then(res => {
                if (res) {
                    if (!this.timer) {
                        this.count = 60
                        this.showCount = true
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= 60) {
                                this.count--
                            } else {
                                this.showCount = false
                                clearInterval(this.timer)
                                this.timer = null
                                this.text = '重新发送'
                            }
                        }, 1000)
                    }
                }
            })
        },
        onSubmit () {
            if (!this.$vuerify.check()) {
                if (typeof (this.$vuerifym.$errors[Object.keys(this.$vuerify.$errors)[0]]) !== 'string') {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]][0])
                } else {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]])
                }
            } else {
                this.$http.post('/api/user/findsetpwd', qs.stringify({
                    step: 1,
                    username: this.info.username,
                    code: this.formItem.code
                })).then(res => {
                    if (res.code === 0) {
                        this.goPage(`/account/entry/step2?username=${this.info.username}`)
                    } else {
                        this.$message.error(res.message)
                    }
                })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .form__center {
        width: 414px;
    }
</style>
